import {JsonObject, JsonProperty} from 'json2typescript';
import {Disabled, EmptyControl, HvlBaseModel, MaxLength} from '@hvlng/framework-bff/core';
import {CodeTextDiscriminatorModel} from '../../../module/code-text/model/code-text-discriminator-model';
import {PerEmployeeCardsDetailModel} from './per-employee-cards-detail-model';

@JsonObject('KovanHrPerEmployeeCardsModel')
export class PerEmployeeCardsModel extends HvlBaseModel {
    @Disabled()
    @JsonProperty('employeeCardId', Number, true)
    employeeCardId: number = null;

    @Disabled()
    @JsonProperty('employeeCardText', String, true)
    employeeCardText: string = null;

    @EmptyControl()
    @JsonProperty('employeeCard', CodeTextDiscriminatorModel, true)
    employeeCard: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('cardUsage', Boolean, true)
    cardUsage: boolean = null;

    @Disabled()
    @JsonProperty('hasApproval', Boolean, true)
    hasApproval: boolean = null;

    @EmptyControl()
    @JsonProperty('approvalUsage', Boolean, true)
    approvalUsage: boolean = null;

    @EmptyControl()
    @JsonProperty('editSelf', Boolean, true)
    editSelf: boolean = null;

    @EmptyControl()
    @JsonProperty('viewSelf', Boolean, true)
    viewSelf: boolean = null;

    @EmptyControl()
    @JsonProperty('viewChild', Boolean, true)
    viewChild: boolean = null;

    @EmptyControl()
    @JsonProperty('willBeTerminated', Boolean, true)
    willBeTerminated: boolean = null;

    @EmptyControl()
    @JsonProperty('useCurrentData', Boolean, true)
    useCurrentData: boolean = null;

    @EmptyControl()
    @JsonProperty('usedInResume', Boolean, true)
    usedInResume: boolean = null;

    @EmptyControl()
    @JsonProperty('deletingPersonnelInformation', Boolean, true)
    deletingPersonnelInformation: boolean = null;

    @EmptyControl()
    @JsonProperty('displayOrder', Number, true)
    displayOrder: number = null;

    @JsonProperty('isVisibleToEmployee', Boolean, true)
    isVisibleToEmployee: boolean = null;

    @EmptyControl()
    @JsonProperty('employeeCardCode', String, true)
    employeeCardCode: string = null;

    @EmptyControl()
    @JsonProperty('perEmployeeCardsDetails', [Object], true)
    perEmployeeCardsDetails?: PerEmployeeCardsDetailModel[] = [];

    perEmployeeCardsDetailsText?: string = null;

    @EmptyControl()
    selectedEmployeeSubtypeIdList: number[] = [];

    @EmptyControl()
    @JsonProperty('iconDisplay', Boolean, true)
    iconDisplay: boolean = null;

    @EmptyControl()
    @JsonProperty('imageDisplay', Boolean, true)
    imageDisplay: boolean = null;

    @EmptyControl()
    @JsonProperty('impactOnPayroll', Boolean, true)
    impactOnPayroll: boolean = null;

    @EmptyControl()
    @MaxLength(50)
    @JsonProperty('iconName', String, true)
    iconName: string = null;

    @EmptyControl()
    @JsonProperty('imageUuid', String, true)
    imageUuid: string = null;

    @EmptyControl()
    @JsonProperty('imageSrc', String, true)
    imageSrc: string = null;

}
